(function () {
	"use strict";

	var SELECTOR = "img:not(.js-img-skeleton):not([data-no-skeleton])";
	var SKIP =
		/[\/.](svg)(\?|$)/i;

	function shouldSkip(img) {
		if (!img || img.tagName !== "IMG") return true;
		if (img.hasAttribute("data-no-skeleton")) return true;
		if (img.classList.contains("js-img-skeleton")) return true;
		// tiny UI icons / tracking pixels
		var w = img.getAttribute("width");
		var h = img.getAttribute("height");
		if (w && h && Number(w) <= 24 && Number(h) <= 24) return true;
		var src = img.currentSrc || img.src || img.getAttribute("data-src") || "";
		if (src && SKIP.test(src)) return true;
		return false;
	}

	function markLoaded(img) {
		img.classList.add("is-loaded");
	}

	function bind(img) {
		if (shouldSkip(img)) return;
		img.classList.add("js-img-skeleton");

		if (img.complete && img.naturalWidth > 0) {
			markLoaded(img);
			return;
		}

		img.addEventListener(
			"load",
			function onLoad() {
				markLoaded(img);
			},
			{ once: true }
		);
		img.addEventListener(
			"error",
			function onError() {
				markLoaded(img);
			},
			{ once: true }
		);
	}

	function scan(root) {
		var scope = root && root.querySelectorAll ? root : document;
		var imgs = scope.querySelectorAll
			? scope.querySelectorAll(SELECTOR)
			: [];
		for (var i = 0; i < imgs.length; i++) {
			bind(imgs[i]);
		}
		// if root itself is an img
		if (root && root.tagName === "IMG") {
			bind(root);
		}
	}

	function init() {
		scan(document);

		if (typeof MutationObserver === "undefined") return;
		var obs = new MutationObserver(function (mutations) {
			for (var i = 0; i < mutations.length; i++) {
				var m = mutations[i];
				if (m.type === "attributes" && m.target.tagName === "IMG") {
					// src / srcset changed — re-show skeleton briefly
					if (m.attributeName === "src" || m.attributeName === "srcset") {
						var img = m.target;
						if (img.hasAttribute("data-no-skeleton")) continue;
						img.classList.add("js-img-skeleton");
						img.classList.remove("is-loaded");
						if (img.complete && img.naturalWidth > 0) {
							markLoaded(img);
						}
					}
					continue;
				}
				var nodes = m.addedNodes;
				for (var j = 0; j < nodes.length; j++) {
					var node = nodes[j];
					if (node.nodeType !== 1) continue;
					if (node.tagName === "IMG") {
						bind(node);
					} else if (node.querySelectorAll) {
						scan(node);
					}
				}
			}
		});
		obs.observe(document.documentElement, {
			childList: true,
			subtree: true,
			attributes: true,
			attributeFilter: ["src", "srcset"],
		});
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();
